"use client"

import dynamic from 'next/dynamic'

const ReactPlayerClient = dynamic(() => import('react-player/lazy'), { ssr: false })

const ReactPlayer = (props) => {
    return <ReactPlayerClient {...props} />
}

export default ReactPlayer